import FileDownloadList from '@components/file-download-list/FileDownloadList';
import Tooltip from '@components/tooltip/tooltip';

const Statement = ({ fileDownload, id, label, name, tooltip, tooltipClickable }) => (
  <div className='statement-container' id={id}>
    <span id={`${name}_label`}>{label}</span>
    {tooltip && <Tooltip clickable={tooltipClickable} content={tooltip} header={label} name={name} />}
    {fileDownload?.length > 0 && <FileDownloadList files={fileDownload} />}
  </div>
);

export default Statement;
